import { Box, Paper, Stack, Typography } from '@mui/material';
import { CounselorDashboard } from '../../types/dashboard';

interface MyPipelineCardProps {
  data?: CounselorDashboard['pipeline'];
}

/** Counselor Dashboard's "My Pipeline" — the same funnel-bar visual as the
 * company-wide Pipeline Overview, but built entirely from this Counselor's
 * own figures (never the company-wide totals — spec §14). */
export const MyPipelineCard = ({ data }: MyPipelineCardProps) => {
  const stages = [
    { label: 'My leads', value: data?.myLeads ?? 0, color: 'primary.main' },
    { label: 'Personal appointments', value: data?.personalAppointments ?? 0, color: 'secondary.main' },
    { label: 'Applications', value: data?.applications ?? 0, color: 'info.main' },
    { label: 'Registered', value: data?.registered ?? 0, color: 'success.main' },
    { label: 'Admissions', value: data?.admissions ?? 0, color: '#0BA5EC' },
    { label: 'Ready to fly', value: data?.readyToFly ?? 0, color: 'warning.main' },
  ];
  const max = Math.max(stages[0].value, 1);

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        My Pipeline
      </Typography>
      <Stack spacing={1.75}>
        {stages.map((stage) => {
          const widthPct = Math.max((stage.value / max) * 100, stage.value > 0 ? 4 : 0);
          return (
            <Box key={stage.label}>
              <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                <Typography variant="body2">{stage.label}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {stage.value}
                </Typography>
              </Stack>
              <Box sx={{ height: 10, borderRadius: 5, bgcolor: 'action.hover', overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${widthPct}%`,
                    borderRadius: 5,
                    bgcolor: stage.color,
                    transition: 'width 0.4s ease',
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};
